/**
 * This code was generated by Builder.io.
 */
import React, { useState, useCallback } from "react";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import styles from "./TableStyles.module.css";

interface RowData {
  office: string;
  period: string;
  status: string;
  lastUpdate: string;
}

const headerData = [
  { label: "Product", icon: "▼" },
  { label: "Report Period", icon: "▼" },
  { label: "Status", icon: "▼" },
  { label: "Last Update", icon: "▼" },
];

const initialRowData: RowData[] = [
  {
    office: "Main Office / 012-1234-4 / ABC Dolor Lorem Ipsum",
    period: "08/2024",
    status: "Submitted",
    lastUpdate: "08/06/2024",
  },
  {
    office: "Main Office / 456-7891-5 / DEF Sed Do",
    period: "06/2024",
    status: "On Hold",
    lastUpdate: "07/05/2024",
  },
  {
    office: "XYZ Office / 019-1234-7 /XYZ Id Est",
    period: "06/2024",
    status: "Processed",
    lastUpdate: "12/04/2024",
  },
  {
    office: "NIT Office / 023-4567-7 / NIT",
    period: "06/2024",
    status: "Processed",
    lastUpdate: "02/03/2024",
  },
  {
    office: "NIT Office / 512-8973-4 / NIUT",
    period: "06/2024",
    status: "Submitted",
    lastUpdate: "21/02/2024",
  },
];

const Table: React.FC = () => {
  const [rowData, setRowData] = useState<RowData[]>(initialRowData);
  const [selectedRows, setSelectedRows] = useState<boolean[]>(
    new Array(initialRowData.length).fill(false)
  );

  const handleRowSelect = useCallback((index: number, isSelected: boolean) => {
    setSelectedRows((prev) => {
      const newSelectedRows = [...prev];
      newSelectedRows[index] = isSelected;
      return newSelectedRows;
    });
  }, []);

  const handleSort = useCallback((label: string) => {
    setRowData((prev) => {
      const newRowData = [...prev];
      newRowData.sort((a, b) => {
        if (label === "Product") return a.office.localeCompare(b.office);
        if (label === "Report Period") return a.period.localeCompare(b.period);
        if (label === "Status") return a.status.localeCompare(b.status);
        if (label === "Last Update")
          return a.lastUpdate.localeCompare(b.lastUpdate);
        return 0;
      });
      return newRowData;
    });
  }, []);

  return (
    <section className={styles.table}>
      <TableHeader headers={headerData} onSort={handleSort} />
      {rowData.map((row, index) => (
        <TableRow
          key={index}
          data={row}
          isSelected={selectedRows[index]}
          onSelect={(isSelected) => handleRowSelect(index, isSelected)}
        />
      ))}
    </section>
  );
};

export default Table;
